//
import PurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'

//
import PurchaseInvoiceAppends from './PurchaseInvoiceAppends'
import PurchaseInvoiceIncludes from './PurchaseInvoiceIncludes'

/**
 *
 */
const fetchAll = async function() {
    //
    try {
        //
        const response = await PurchaseInvoiceModel.append(PurchaseInvoiceAppends)
            .include(PurchaseInvoiceIncludes)
            .params({ get_all_results: true })
            .get()
        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default fetchAll
